export const parseAmount = amount => {
  if (amount.toLowerCase && amount.toLowerCase() === 'calc') {
    return null;
  }

  if (amount === '') {
    return 0;
  }

  if (!isNaN(amount)) {
    return Number(amount);
  }

  return amount;
};
